import { render, staticRenderFns } from "./returnResult.vue?vue&type=template&id=62ad222c&scoped=true&"
import script from "./returnResult.vue?vue&type=script&lang=js&"
export * from "./returnResult.vue?vue&type=script&lang=js&"
import style0 from "./returnResult.vue?vue&type=style&index=0&id=62ad222c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ad222c",
  null
  
)

export default component.exports